module.exports = [{
      plugin: require('../node_modules/gatsby-plugin-manifest/gatsby-browser.js'),
      options: {"plugins":[],"name":"gatsby-starter-default","short_name":"starter","start_url":"/","background_color":"#cf1f32","theme_color":"#cf1f32","display":"minimal-ui","icon":"src/images/agewell-favicon.png","cache_busting_mode":"query","include_favicon":true,"legacy":true,"theme_color_in_head":true,"cacheDigest":"9121e28ad335495c9802032e82deab67"},
    },{
      plugin: require('../gatsby-browser.js'),
      options: {"plugins":[]},
    }]
